export default __webpack_public_path__ + "static/bef-79619217238644033111608b0a6f1fdd.png";